'use strict'

module.exports = Backbone.View.extend
  render: (html) ->
    @$el.html(html)
